import { useI18n } from '@cascade/react/i18n';
import { useProjects } from '@cascade/react/projects';
import { Text } from '@cascade/ui-library';
import classes from './ExperienceExplorer.module.scss';
import type { TExperienceExplorerProps } from './ExperienceExplorer.types.ts';
import { ExperienceCard } from '#components/experience-card/index.ts';

export const ExperienceExplorer = ({
  experiences,
}: TExperienceExplorerProps) => {
  const { translate } = useI18n();
  const { settings } = useProjects();

  const title =
    settings?.experience_explorer_title ?? translate('experiences.title');

  const description =
    settings?.experience_explorer_description ??
    translate('experiences.description');

  return (
    <section className={classes['experience-explorer']} aria-label={title}>
      <Text type='h1' weight='semibold' content={title} compact />
      <Text type='body-2' color='text-60' content={description} compact />
      <ul className={classes.experiences}>
        {experiences.map((experience) => (
          <li key={experience.id}>
            <ExperienceCard
              experience={experience}
              isRecommended={Boolean(experience.highlighted)}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
